import {Tournament, Participant} from '../types'

//const PLAYER_FREQUENCY_PENALTY = 1;
//const CONSECUTIVE_MATCH_PENALTY = 3;
const DUPLICATE_TEAM_PENALTY = 5;

//Sjekke om folk spiller etter hverandre

//Sjekke om 2 lag skjer flere ganger
export const EvaluateDuplicateTeams =  (tournament:Tournament):number => {
    if(!tournament) throw new Error();
    let teamsTable = {}
    let score = 0;
    tournament.GroupStageGames.forEach((game) => {
        //Først må vi sortere lagkombinasjonen
        teamsTable = AddTeamToTable(teamsTable, game.TeamBlue);
        teamsTable = AddTeamToTable(teamsTable, game.TeamRed);
    })

    Object.entries(teamsTable).forEach((t) => {
        const frequency = t[1] as number;
        if(frequency > 1){
            score += (frequency * DUPLICATE_TEAM_PENALTY)
        }
    })

    return score;
}

export const AddTeamToTable = (teamsTable: any, team: Participant[]):any => {
    const teamHash = GetTeamHash(team);
    if(teamHash in teamsTable){
        teamsTable[teamHash] = teamsTable[teamHash] + 1; 
    }else{
        teamsTable[teamHash] = 1;
    }
    return teamsTable
}

export const GetTeamHash = (team: Participant[]) => {
    const sortedTeam = team.sort((a,b) => a.Number-b.Number);
    let hash = '';
    sortedTeam.forEach((p) => hash += (p.Number + p.Name));
    return hash;
}
